module.exports = __webpack_public_path__ + "static/media/netflix_homepage-promo.7b91b4cd.jpg";